import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentGroupOrder, getListGroupOrder } from '../../selectors'
import GroupOrderHeader from '../../components/common/GroupOrderHeader'
import { delGroupOrder, selectGroupOrder } from '../../actions/orderActions'

const ListFoodWithGroup = ({
    listFood,
    renderFood,
    isOrdered,
    scrollToBottomCurrentGroup,
    listGroupOrdered,
    hideLabelGroup
}) => {
    const currentGroupOrder = useSelector(getCurrentGroupOrder)
    const listGroupOrdering = useSelector(getListGroupOrder)
    const dispatch = useDispatch()

    const handleSelectGroup = groupId =>
        groupId !== currentGroupOrder && dispatch(selectGroupOrder({ groupId }))

    const handleDelGroup = groupId => dispatch(delGroupOrder({ groupId }))

    const renderListFoodWithGroup = () => {
        const rs = [];

        let foodCount = 0;
        let groupCount = 0;
        const listGroup = listGroupOrdered || listGroupOrdering
        for (let group of listGroup) {
            const listFoodByGroup = listFood.filter(
                food => +food.groupOrder === group
            )
            const groupOrderId = `group-order-${group}`
            const disableRemove = listFoodByGroup.some(food => food.submitted)

            rs.push(
                <div id={groupOrderId} key={groupOrderId}>
                    {!hideLabelGroup && (
                        <GroupOrderHeader
                            groupCount={++groupCount}
                            groupId={group}
                            handleSelectGroup={handleSelectGroup}
                            handleDelGroup={handleDelGroup}
                            isActive={!isOrdered && currentGroupOrder === group}
                            viewOnly={isOrdered}
                            removeAble={!disableRemove}
                        />
                    )}
                    {listFoodByGroup.map(food => renderFood(food, foodCount++))}
                </div>
            )
        }

        return rs
    }

    useEffect(() => {
        if (scrollToBottomCurrentGroup) {
            try {
                const listGroup = listGroupOrdered || listGroupOrdering
                const groupEle = document.getElementById(
                    `group-order-${currentGroupOrder}`
                )
                const viewHeight = window.innerHeight
                const heightHeaderAndFooter = 182
                let offset =
                    groupEle.offsetTop +
                    groupEle.getBoundingClientRect().height +
                    heightHeaderAndFooter -
                    viewHeight
                offset +=
                    listGroup[listGroup.length - 1] === currentGroupOrder
                        ? 72
                        : 44
                document.getElementById('cart-food-list').scrollTop = offset
            } catch (error) {}
        }
    }, [])

    return renderListFoodWithGroup()
}

export default ListFoodWithGroup
